export const DEFAULT_ERROR_MESSAGE =
  'An error occurred. Please contact support if the problem persists.';
